/**
 * Shared spring for the sliding tab highlight.
 *
 * Separate from `TabPill.jsx` because fast refresh only works when a module
 * exports components alone — mixing a constant in silently disables it for the
 * whole file.
 */
export const TAB_PILL_TRANSITION = { type: 'spring', stiffness: 500, damping: 38 };
